// Initialize topbar swiper
window.addEventListener('DOMContentLoaded', function initTopbarSwiper() {
  if (typeof Swiper === 'undefined') return;

  const topbarSwiper = new Swiper('.topbar-swiper', {
    direction: 'horizontal',
    loop: true,
    allowTouchMove: false,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    speed: 600,
    effect: 'slide',
  });
});

// Header scroll effect - add background when scrolling
// window.addEventListener('DOMContentLoaded', function initHeaderScrollEffect() {
//   const header = document.querySelector('.main-header');
  
//   if (!header) return;
  
//   function handleScroll() {
//     if (window.scrollY > 50) {
//       header.classList.add('nav-hover');
//     } else {
//       header.classList.remove('nav-hover');
//     }
//   }
  
//   // Add scroll event listener
//   window.addEventListener('scroll', handleScroll);
  
//   // Check initial scroll position
//   handleScroll();
// });
window.addEventListener('DOMContentLoaded', function initHeaderScrollEffect() {
  const header = document.querySelector('.main-header');

  if (!header) return;

  // Check if current page is NOT index.html
  // Handles both '/index.html' and root '/' as home/index
  const isHomePage =
    window.location.pathname === '/' ||
    window.location.pathname.endsWith('/index');

  if (!isHomePage) {
    // Add nav-hover class by default
    header.classList.add('nav-hover-new');
  } else {
    // Apply scroll effect only on index.html / homepage
    function handleScroll() {
      if (window.scrollY > 50) {
        header.classList.add('nav-hover-new');
      } else {
        header.classList.remove('nav-hover-new');
      }
    }
    window.addEventListener('scroll', handleScroll);
    handleScroll();
  }
});


// Countdown Timer for Limited Time Offer
// window.addEventListener('DOMContentLoaded', function initCountdownTimer() {
//   // Check if we have the countdown elements
//   const daysElement = document.getElementById('days');
//   const hoursElement = document.getElementById('hours');
//   const minutesElement = document.getElementById('minutes');
//   const secondsElement = document.getElementById('seconds');
  
//   if (!daysElement || !hoursElement || !minutesElement || !secondsElement) {
//     return; // Exit if countdown elements don't exist
//   }
  
//   // Try to get stored end date from localStorage, or create a new one
//   let endDate;
//   const storedEndDate = localStorage.getItem('limitedOfferEndDate');
  
//   if (storedEndDate) {
//     endDate = new Date(storedEndDate);
//     // Check if the stored date is still valid (not expired)
//     if (endDate <= new Date()) {
//       // Create new offer date if expired
//       endDate = new Date();
//       endDate.setDate(endDate.getDate() + 7); // 7 days from now
//       endDate.setHours(23, 59, 59, 999); // End of day
//       localStorage.setItem('limitedOfferEndDate', endDate.toISOString());
//     }
//   } else {
//     // Create new offer date
//     endDate = new Date();
//     endDate.setDate(endDate.getDate() + 7); // 7 days from now
//     endDate.setHours(23, 59, 59, 999); // End of day
//     localStorage.setItem('limitedOfferEndDate', endDate.toISOString());
//   }
  
//   function updateCountdown() {
//     const now = new Date().getTime();
//     const distance = endDate.getTime() - now;
    
//     if (distance < 0) {
//       // Offer has expired - create new offer
//       endDate = new Date();
//       endDate.setDate(endDate.getDate() + 7);
//       endDate.setHours(23, 59, 59, 999);
//       localStorage.setItem('limitedOfferEndDate', endDate.toISOString());
      
//       // Add some visual feedback for new offer
//       const countdownItems = document.querySelectorAll('.countdown-item');
//       countdownItems.forEach(item => {
//         item.style.animation = 'none';
//         setTimeout(() => {
//           item.style.animation = 'fadeInUp 0.6s ease-out';
//         }, 10);
//       });
      
//       return;
//     }
    
//     // Calculate time units
//     const days = Math.floor(distance / (1000 * 60 * 60 * 24));
//     const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//     const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
//     const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
//     // Update the display with smooth transitions
//     updateElementWithAnimation(daysElement, days.toString().padStart(2, '0'));
//     updateElementWithAnimation(hoursElement, hours.toString().padStart(2, '0'));
//     updateElementWithAnimation(minutesElement, minutes.toString().padStart(2, '0'));
//     updateElementWithAnimation(secondsElement, seconds.toString().padStart(2, '0'));
//   }
  
//   function updateElementWithAnimation(element, newValue) {
//     if (element.textContent !== newValue) {
     
      
//       setTimeout(() => {
//         element.textContent = newValue;
      
//       }, 150);
//     }
//   }
  
//   // Update countdown every second
//   updateCountdown();
//   const countdownInterval = setInterval(updateCountdown, 1000);
  
//   // Clean up interval when page is hidden (for better performance)
//   document.addEventListener('visibilitychange', function() {
//     if (document.hidden) {
//       clearInterval(countdownInterval);
//     } else {
//       updateCountdown();
//       setInterval(updateCountdown, 1000);
//     }
//   });
// });

// Initialize fashion carousel swiper
window.addEventListener('DOMContentLoaded', function initFashionSwiper() {
  if (typeof Swiper === 'undefined') return;

  const fashionSwiper = new Swiper('.fashion-swiper', {
    direction: 'horizontal',
    loop: true,
    slidesPerView: 2.4,
    spaceBetween: 6,
    // autoplay: {
    //   delay: 3000,
    //   disableOnInteraction: false,
    // },
    // speed: 600,
    effect: 'slide',
    navigation: {
      nextEl: '.fashion-next-arrow',
      prevEl: '.fashion-prev-arrow',
    },
    breakpoints: {
      360: {
        slidesPerView: 3.1,
        spaceBetween: 6,
      },
      600: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1025: {
        slidesPerView: 5.3,
        spaceBetween: 23,
      }
    }
  });
});

// Initialize product carousel swiper
window.addEventListener('DOMContentLoaded', function initProductCarousel() {
  if (typeof Swiper === 'undefined') return;

  const productCarousel = new Swiper('.product-small-carousel', {
    loop: true,
    slidesPerView: 1.4,
    spaceBetween: 0,
    effect: 'slide',
    navigation: {
      nextEl: '.product-small-carousel-button-next',
      prevEl: '.product-small-carousel-button-prev',
    },
    pagination: {
      el: '.product-small-carousel-pagination',
      clickable: true,
      type: 'bullets',
    },
    // autoplay: {
    //   delay: 4000,
    //   disableOnInteraction: false,
    // },
    // speed: 600,
    breakpoints: {
      320: {
        slidesPerView: 1.4,
        spaceBetween: 15,
        pagination: {
          el: '.product-small-carousel-pagination',
          clickable: true,
          type: 'progressbar',
        },
      },  
      600: {
        slidesPerView: 1.8,
        spaceBetween: 15,
        pagination: {
          el: '.product-small-carousel-pagination',
          clickable: true,
          type: 'progressbar',
        },
      },  
      
      992: {
        slidesPerView: 1.9,
        spaceBetween: 20,
        pagination: {
          el: '.product-small-carousel-pagination',
          clickable: true,
          type: 'progressbar',
        },
      },
      1025: {
        slidesPerView: 1.3,
        spaceBetween: 20,
      }
    }
  });
});

// Initialize Print Rules product slider swiper
window.addEventListener('DOMContentLoaded', function initPrintRulesSlider() {
  if (typeof Swiper === 'undefined') return;

  const printRulesSlider = new Swiper('.product-slider', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    effect: 'slide',
    navigation: {
      nextEl: '.print-rules-button-next',
      prevEl: '.print-rules-button-prev',
    },
   
    // autoplay: {
    //   delay: 4000,
    //   disableOnInteraction: false,
    // },
    speed: 600,
  });
});

// Video functionality
window.addEventListener('DOMContentLoaded', function initVideo() {
  const playBtn = document.getElementById('playBtn');
  const heroPicture = document.getElementById('heroPicture');
  const heroVideo = document.getElementById('heroVideo');
  const videoControls = document.getElementById('videoControls');
  const playPauseBtn = document.getElementById('playPauseBtn');
  const muteBtn = document.getElementById('muteBtn');
  const closeBtn = document.getElementById('closeBtn');

  if (!playBtn || !heroPicture || !heroVideo || !videoControls) return;

  // Play button click - replace image with video
  playBtn.addEventListener('click', function() {
    heroPicture.style.display = 'none';
    heroVideo.style.display = 'block';
    videoControls.style.display = 'flex';
    playBtn.style.display = 'none';
    
    // Start playing the video
    heroVideo.play();
    playPauseBtn.classList.add('playing');
  });

  // Play/Pause button
  playPauseBtn.addEventListener('click', function() {
    if (heroVideo.paused) {
      heroVideo.play();
      playPauseBtn.classList.add('playing');
    } else {
      heroVideo.pause();
      playPauseBtn.classList.remove('playing');
    }
  });

  // Mute/Unmute button
  muteBtn.addEventListener('click', function() {
    if (heroVideo.muted) {
      heroVideo.muted = false;
      muteBtn.classList.remove('muted');
    } else {
      heroVideo.muted = true;
      muteBtn.classList.add('muted');
    }
  });

  // Close button - return to image
  closeBtn.addEventListener('click', function() {
    heroVideo.pause();
    heroVideo.currentTime = 0;
    heroVideo.style.display = 'none';
    videoControls.style.display = 'none';
    heroPicture.style.display = 'block';
    playBtn.style.display = 'flex';
    playPauseBtn.classList.remove('playing');
  });

  // Video ended event - return to image
  heroVideo.addEventListener('ended', function() {
    heroVideo.style.display = 'none';
    videoControls.style.display = 'none';
    heroPicture.style.display = 'block';
    playBtn.style.display = 'flex';
    playPauseBtn.classList.remove('playing');
  });
});



// Mega Menu functionality
window.addEventListener('DOMContentLoaded', function initMegaMenu() {
  const navItems = document.querySelectorAll('.nav-list > li');
  const header = document.querySelector('.main-header'); // <-- header element
  let hideTimeout;

  navItems.forEach(item => {
    const megaMenu = item.querySelector('.mega-menu');
    if (!megaMenu) return; // Skip li without mega menu

    const tabsGroup = megaMenu.querySelector('.mega-tab-group');
    const productsGroup = megaMenu.querySelector('.mega-products-group');

    // Show mega menu on hover
    item.addEventListener('mouseenter', () => {
      clearTimeout(hideTimeout);

      // Hide all open mega menus first
      document.querySelectorAll('.mega-menu.active').forEach(menu => {
        menu.classList.remove('active');
      });

      // Show only this one
      megaMenu.classList.add('active');
      header.classList.add('nav-hover'); // <-- Add nav-hover on header

      // Reset tabs → first tab active by default
      if (tabsGroup) {
        const allTabs = tabsGroup.querySelectorAll('.mega-tab');
        const firstTab = allTabs[0];

        allTabs.forEach(tab => tab.classList.remove('active'));
        if (firstTab) {
          firstTab.classList.add('active');
          showTabContent(productsGroup, firstTab.dataset.tab);
        }
      }
    });

    // Hide mega menu on leave
    item.addEventListener('mouseleave', () => {
      hideTimeout = setTimeout(() => {
        megaMenu.classList.remove('active');

        // Check if any menu is still open
        const anyActive = document.querySelector('.mega-menu.active');
        if (!anyActive) {
          header.classList.remove('nav-hover'); // <-- Remove only when no active mega menu
        }
      }, 150);
    });

    // Keep open when hovering inside mega menu
    megaMenu.addEventListener('mouseenter', () => {
      clearTimeout(hideTimeout);
    });
    megaMenu.addEventListener('mouseleave', () => {
      megaMenu.classList.remove('active');

      // Remove nav-hover only if nothing open
      const anyActive = document.querySelector('.mega-menu.active');
      if (!anyActive) {
        header.classList.remove('nav-hover');
      }
    });

    // Tab click functionality
    if (tabsGroup) {
      const tabs = tabsGroup.querySelectorAll('.mega-tab');
      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          // Remove active from all tabs
          tabs.forEach(t => t.classList.remove('active'));
          tab.classList.add('active');

          // Show corresponding content
          showTabContent(productsGroup, tab.dataset.tab);
        });
      });
    }
  });

  // Helper: Show tab content
  function showTabContent(productsGroup, tabName) {
    if (!productsGroup) return;

    const allContent = productsGroup.querySelectorAll('.mega-products-content');
    allContent.forEach(c => c.style.display = 'none');

    const selectedContent = productsGroup.querySelector(`[data-tab="${tabName}"]`);
    if (selectedContent) {
      selectedContent.style.display = 'block';
    }
  }
});



// Mobile Navigation functionality
// window.addEventListener('DOMContentLoaded', function initMobileNav() {
//   const burgerMenuBtn = document.querySelector('.burger-menu-btn.tablet-only');
//   const mobileNavPanel = document.getElementById('mobileNavPanel');
//   const closeMenuBtn = document.querySelector('.close-menu-btn');
//   const mainHeader = document.querySelector('.main-header');
//   const mainMobileNav = document.getElementById('mainMobileNav');
//   const submenus = document.querySelectorAll('.mobile-submenu');
//   const backBtns = document.querySelectorAll('.back-btn');
  
//   // Also get mobile navbar menu button
//   const mobileMenuBtn = document.querySelector('.menu-btn');
  
//   if (!mobileNavPanel || !closeMenuBtn || !mainHeader || !mainMobileNav) return;
  
//   // Function to close mobile menu
//   function closeMobileMenu() {
//     mobileNavPanel.classList.remove('active');
//     mainHeader.classList.remove('tab-active');
//     document.body.style.overflow = ''; // Restore body scroll
    
//     // Hide all submenus
//     submenus.forEach(submenu => {
//       submenu.classList.remove('active');
//       submenu.style.display = 'none';
//     });
    
//     // Show main navigation
//     mainMobileNav.style.display = 'block';
//   }
  
//   // Function to show submenu
//   function showSubmenu(submenuType) {
//     // Hide main navigation
//     mainMobileNav.style.display = 'none';
    
//     // Show the specific submenu
//     const targetSubmenu = document.getElementById(`${submenuType}Submenu`);
//     if (targetSubmenu) {
//       targetSubmenu.style.display = 'flex';
//       targetSubmenu.classList.add('active');
//     }
//   }
  
//   // Function to go back to main menu
//   function goBackToMainMenu() {
//     // Hide all submenus
//     submenus.forEach(submenu => {
//       submenu.classList.remove('active');
//       submenu.style.display = 'none';
//     });
    
//     // Show main navigation
//     mainMobileNav.style.display = 'block';
//   }
  
//   // Open mobile menu from header burger button
//   if (burgerMenuBtn) {
//     burgerMenuBtn.addEventListener('click', function() {
//       mobileNavPanel.classList.add('active');
//       mainHeader.classList.add('tab-active');
//       document.body.style.overflow = 'hidden'; // Prevent body scroll
//     });
//   }
  
//   // Open mobile menu from mobile navbar menu button
//   if (mobileMenuBtn) {
//     mobileMenuBtn.addEventListener('click', function() {
//       mobileNavPanel.classList.add('active');
//       mainHeader.classList.add('tab-active');
//       document.body.style.overflow = 'hidden'; // Prevent body scroll
//     });
//   }
  
//   // Close mobile menu
//   closeMenuBtn.addEventListener('click', closeMobileMenu);
  
//   // Handle submenu clicks
//   const mobileNavLinks = document.querySelectorAll('.mobile-nav-link[data-submenu]');
//   mobileNavLinks.forEach(link => {
//     link.addEventListener('click', function(e) {
//       e.preventDefault();
//       const submenuType = this.getAttribute('data-submenu');
//       showSubmenu(submenuType);
//     });
//   });
  
//   // Handle back button clicks
//   backBtns.forEach(btn => {
//     btn.addEventListener('click', goBackToMainMenu);
//   });
  
//   // Close menu on escape key
//   document.addEventListener('keydown', function(e) {
//     if (e.key === 'Escape' && mobileNavPanel.classList.contains('active')) {
//       closeMobileMenu();
//     }
//   });
  
//   // Close menu when clicking outside
//   document.addEventListener('click', function(e) {
//     if (mobileNavPanel.classList.contains('active') && 
//         !mobileNavPanel.contains(e.target) && 
//         !(burgerMenuBtn && burgerMenuBtn.contains(e.target)) &&
//         !(mobileMenuBtn && mobileMenuBtn.contains(e.target))) {
//       closeMobileMenu();
//     }
//   });
// });
window.addEventListener('DOMContentLoaded', function initMobileNav() {
  const burgerMenuBtn = document.querySelector('.burger-menu-btn.tablet-only');
  const mobileNavPanel = document.getElementById('mobileNavPanel');
  const closeMenuBtn = document.querySelector('.close-menu-btn');
  const mainHeader = document.querySelector('.main-header');
  const mainMobileNav = document.getElementById('mainMobileNav');
  const submenus = document.querySelectorAll('.mobile-submenu');
  const backBtns = document.querySelectorAll('.back-btn');
  
  // Also get mobile navbar menu button
  const mobileMenuBtn = document.querySelector('.menu-btn');
  
  if (!mobileNavPanel || !closeMenuBtn || !mainHeader || !mainMobileNav) return;
  
  // Function to close mobile menu
  function closeMobileMenu() {
    mobileNavPanel.classList.remove('active');
    mainHeader.classList.remove('tab-active');
    document.body.style.overflow = ''; // Restore body scroll
    
    // Hide all submenus
    submenus.forEach(submenu => {
      submenu.classList.remove('active');
      submenu.style.display = 'none';
    });
    
    // Show main navigation
    mainMobileNav.style.display = 'block';
  }
  
  // Function to show submenu
  function showSubmenu(submenuType) {
    // Hide main navigation
    mainMobileNav.style.display = 'none';
    
    // Show the specific submenu
    const targetSubmenu = document.getElementById(`${submenuType}Submenu`);
    if (targetSubmenu) {
      targetSubmenu.style.display = 'flex';
      targetSubmenu.classList.add('active');
    }
  }
  
  // Function to go back to main menu
  function goBackToMainMenu() {
    // Hide all submenus
    submenus.forEach(submenu => {
      submenu.classList.remove('active');
      submenu.style.display = 'none';
    });
    
    // Show main navigation
    mainMobileNav.style.display = 'block';
  }
  
  // Function to go back to category menu
  function goBackToCategoryMenu(category) {
    // Hide all submenus
    submenus.forEach(submenu => {
      submenu.classList.remove('active');
      submenu.style.display = 'none';
    });
    
    // Show category submenu
    showSubmenu(category);
  }
  
  // Open mobile menu from header burger button
  if (burgerMenuBtn) {
    burgerMenuBtn.addEventListener('click', function() {
      mobileNavPanel.classList.add('active');
      mainHeader.classList.add('tab-active');
      document.body.style.overflow = 'hidden'; // Prevent body scroll
    });
  }
  
  // Open mobile menu from mobile navbar menu button
  if (mobileMenuBtn) {
    mobileMenuBtn.addEventListener('click', function() {
      mobileNavPanel.classList.add('active');
      mainHeader.classList.add('tab-active');
      document.body.style.overflow = 'hidden'; // Prevent body scroll
    });
  }
  
  // Close mobile menu
  closeMenuBtn.addEventListener('click', closeMobileMenu);
  
  // Handle all navigation clicks (main nav, category nav, product nav)
  const allNavLinks = document.querySelectorAll('.mobile-nav-link[data-submenu], .mobile-category-link[data-submenu]');
  allNavLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const submenuType = this.getAttribute('data-submenu');
      showSubmenu(submenuType);
    });
  });
  
  // Handle back button clicks
  backBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const submenu = this.closest('.mobile-submenu');
      const submenuType = submenu.getAttribute('data-submenu');
      
      // Check if this is a product submenu (has category in the name)
      if (submenuType.includes('Clothing') || submenuType.includes('Accessories') || 
          submenuType.includes('Trending') || submenuType.includes('New') || 
          submenuType.includes('Lookbook')) {
        // Go back to category menu
        const category = submenuType.replace(/Clothing|Accessories|Trending|New|Lookbook/, '').toLowerCase();
        goBackToCategoryMenu(category);
      } else if (submenuType === 'mens' || submenuType === 'kids') {
        // Go back to main menu from category menu
        goBackToMainMenu();
      } else {
        // Default: go back to main menu
        goBackToMainMenu();
      }
    });
  });
  
  // Close menu on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && mobileNavPanel.classList.contains('active')) {
      closeMobileMenu();
    }
  });
  
  // Close menu when clicking outside
  document.addEventListener('click', function(e) {
    if (mobileNavPanel.classList.contains('active') && 
        !mobileNavPanel.contains(e.target) && 
        !(burgerMenuBtn && burgerMenuBtn.contains(e.target)) &&
        !(mobileMenuBtn && mobileMenuBtn.contains(e.target))) {
      closeMobileMenu();
    }
  });
});


document.addEventListener("DOMContentLoaded", function() {
  // Select all submenu items that have a grandchild submenu list
  const submenuItems = document.querySelectorAll('.submenu-item');

  submenuItems.forEach(function(item) {
    const grandSubmenu = item.querySelector('.grand-submenu-list');
    const submenuLink = item.querySelector('.submenu-link');

    // Only add click if a grand-submenu exists
    if (grandSubmenu && submenuLink) {
      submenuLink.addEventListener('click', function(e) {
        e.preventDefault();

        // Close all other grand-submenu-lists
        document.querySelectorAll('.grand-submenu-list').forEach(function(list) {
          if (list !== grandSubmenu) {
            list.style.display = 'none';
          }
        });

        // Toggle the clicked item's grand-submenu-list
        if (grandSubmenu.style.display === 'block') {
          grandSubmenu.style.display = 'none';
        } else {
          grandSubmenu.style.display = 'block';
        }
      });
    }
  });
});



// Handle resize events for responsive behavior
window.addEventListener('resize', function handleResize() {
  const mobileNavPanel = document.getElementById('mobileNavPanel');
  const mainHeader = document.querySelector('.main-header');
  
  // Hide mobile menu on desktop
  if (window.innerWidth > 1023 && mobileNavPanel) {
    mobileNavPanel.classList.remove('active');
    mainHeader.classList.remove('tab-active');
    document.body.style.overflow = '';
    
    // Also ensure submenus are hidden and main nav is shown on resize to desktop
    const mainMobileNav = document.getElementById('mainMobileNav');
    const submenus = document.querySelectorAll('.mobile-submenu');
    if (mainMobileNav) mainMobileNav.style.display = 'block';
    submenus.forEach(submenu => {
      submenu.classList.remove('active');
      submenu.style.display = 'none';
    });
  }
});

// Header navigation hover effect
window.addEventListener('DOMContentLoaded', function initHeaderHover() {
  const mainHeader = document.querySelector('.main-header');
  const navLinks = document.querySelectorAll('.nav-link');
  const megaMenu = document.getElementById('megaMenu');
  
  if (!mainHeader || navLinks.length === 0) return;
  
  // Add hover class to main-header when hovering over nav-links
  navLinks.forEach(link => {
    link.addEventListener('mouseenter', function() {
      mainHeader.classList.add('nav-hover');
    });
  });
  
  // Keep nav-hover class active when mega menu is open
  if (megaMenu) {
    megaMenu.addEventListener('mouseenter', function() {
      mainHeader.classList.add('nav-hover');
    });
    
    megaMenu.addEventListener('mouseleave', function() {
      mainHeader.classList.remove('nav-hover');
    });
  }
  
  // Remove nav-hover class when leaving navigation area (but not when mega menu is open)
  const headerNav = document.querySelector('.header-nav');
  if (headerNav) {
    headerNav.addEventListener('mouseleave', function(e) {
      // Only remove the class if we're not entering the mega menu
      const relatedTarget = e.relatedTarget;
      if (!megaMenu || !megaMenu.contains(relatedTarget)) {
        mainHeader.classList.remove('nav-hover');
      }
    });
  }
});

// Fullscreen Slider functionality
window.addEventListener('DOMContentLoaded', function initFullscreenSlider() {
  if (typeof Swiper === 'undefined') return;

  const fullscreenSwiper = new Swiper('.fullscreen-swiper', {
    direction: 'horizontal',
    loop: true,
    // autoplay: {
    //   delay: 5000,
    //   disableOnInteraction: false,
    // },
    speed: 1000,
  
    navigation: {
      nextEl: '.fullscreen-next-arrow',
      prevEl: '.fullscreen-prev-arrow',
    },
   
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      // dynamicBullets: true,
    },
   
    breakpoints: {
      320: {
        allowTouchMove: true,
        autoplay: {
          delay: 4000,
         
        }
      },
      768: {
        allowTouchMove: true,
        autoplay: {
          delay: 4500,
        }
      },
      1024: {
        allowTouchMove: true,
        autoplay: {
          delay: 5000,
        }
      }
    }
  });

  // Pause autoplay on hover
  // const sliderContainer = document.querySelector('.fullscreen-swiper');
  // if (sliderContainer) {
  //   sliderContainer.addEventListener('mouseenter', function() {
  //     fullscreenSwiper.autoplay.stop();
  //   });
    
  //   sliderContainer.addEventListener('mouseleave', function() {
  //     fullscreenSwiper.autoplay.start();
  //   });
  // }
});

// Second Fullscreen Slider functionality
window.addEventListener('DOMContentLoaded', function initSecondFullscreenSlider() {
  if (typeof Swiper === 'undefined') return;

  const fullscreenSwiperSecond = new Swiper('.fullscreen-swiper-second', {
    direction: 'horizontal',
    loop: true,
    speed: 1000,
  
    navigation: {
      nextEl: '.fullscreen-next-arrow-second',
      prevEl: '.fullscreen-prev-arrow-second',
    },
   
    pagination: {
      el: '.fullscreen-slider-second .swiper-pagination',
      clickable: true,
    },
   
    breakpoints: {
      320: {
        allowTouchMove: true,
        autoplay: {
          delay: 4000,
        }
      },
      768: {
        allowTouchMove: true,
        autoplay: {
          delay: 4500,
        }
      },
      1024: {
        allowTouchMove: true,
        autoplay: {
          delay: 5000,
        }
      }
    }
  });
});

// Flow-3 New Section Swiper functionality
window.addEventListener('DOMContentLoaded', function initFlow3Swiper() {
  if (typeof Swiper === 'undefined') return;

  const flow3Swiper = new Swiper('.flow-3-swiper', {
   
    loop: true,
    speed: 800,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    pagination: {
      el: '.flow-3-pagination',
      clickable: true,
      type: 'bullets',
      bulletClass: 'swiper-pagination-bullet',
      bulletActiveClass: 'swiper-pagination-bullet-active',
    },
    breakpoints: {
      320: {
        allowTouchMove: true,
        autoplay: {
          delay: 3500,
        }
      },
      768: {
        allowTouchMove: true,
        autoplay: {
          delay: 4000,
        }
      },
      1025: {
        allowTouchMove: true,
        autoplay: {
          delay: 4500,
        }
      }
    }
  });
});

// Search Overlay functionality
window.addEventListener('DOMContentLoaded', function initSearchOverlay() {
  const searchOverlay = document.getElementById('searchOverlay');
  const searchInput = document.getElementById('searchInput');
  
  // Get all search buttons (desktop, tablet, and mobile navbar)
  const searchButtons = document.querySelectorAll('.search-area, .action-btn[aria-label="Search"], .search-btn');
  
  if (!searchOverlay) return;
  
  // Open search overlay when search button is clicked
  searchButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      searchOverlay.classList.add('active');
      document.body.style.overflow = 'hidden'; // Prevent background scrolling
      
      // Focus on search input after a short delay for smooth animation
      setTimeout(() => {
        searchInput.focus();
      }, 300);
    });
  });
  
  // Close search overlay when clicking outside the content
  searchOverlay.addEventListener('click', function(e) {
    // Close when clicking on the overlay background (outside the content)
    if (e.target === searchOverlay) {
      searchOverlay.classList.remove('active');
      document.body.style.overflow = '';
      searchInput.value = '';
    }
  });
  
  // Also close when clicking on the document body outside the overlay
  document.addEventListener('click', function(e) {
    if (searchOverlay.classList.contains('active') && 
        !searchOverlay.contains(e.target) && 
        !e.target.closest('.search-area') && 
        !e.target.closest('.action-btn[aria-label="Search"]') &&
        !e.target.closest('.search-btn')) {
      searchOverlay.classList.remove('active');
      document.body.style.overflow = '';
      searchInput.value = '';
    }
  });
  
  // Close search overlay with Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && searchOverlay.classList.contains('active')) {
      searchOverlay.classList.remove('active');
      document.body.style.overflow = '';
      searchInput.value = '';
    }
  });
  
  // Handle search input functionality
  // searchInput.addEventListener('input', function(e) {
  //   const query = e.target.value.trim();
  //   // Add search logic here if needed
  //   console.log('Searching for:', query);
  // });
  
  // // Handle search form submission
  // searchInput.addEventListener('keypress', function(e) {
  //   if (e.key === 'Enter') {
  //     const query = e.target.value.trim();
  //     if (query) {
  //       // Add search submission logic here
  //       console.log('Search submitted:', query);
  //       // You can redirect to search results page or perform AJAX search
  //     }
  //   }
  // });
  document.addEventListener('DOMContentLoaded', function () {
  // find the input (try class first, then id)
  const searchInput = document.querySelector('.search-input') || document.getElementById('searchInput');

  // if not found, stop early (prevents "cannot read property 'addEventListener' of null")
  if (!searchInput) {
    console.warn('search input not found in DOM');
    return;
  }

  // Handle live input
  searchInput.addEventListener('input', function (e) {
    const query = e.target.value.trim();
    console.log('Searching for:', query);
  });

  // Handle Enter key (use keydown — more reliable than keypress)
  searchInput.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault(); // prevent default form submit if inside a form
      const query = this.value.trim();
      if (query) {
        console.log('Search submitted:', query);
        // put your search submission logic here (redirect or AJAX)
      }
    }
  });
});

});

// Cart Overlay functionality
window.addEventListener('DOMContentLoaded', function initCartOverlay() {
  const cartOverlay = document.getElementById('cartOverlay');
  const cartCloseBtn = document.getElementById('cartCloseBtn');
  const cartTabs = document.querySelectorAll('.cart-tab');
  const tabContents = document.querySelectorAll('.tab-content');
  
  // Get all cart buttons (desktop, tablet, and mobile navbar)
  const cartButtons = document.querySelectorAll('.cart-area, .action-btn[aria-label="Cart"], .cart-icon, .cart-btn');
  
  if (!cartOverlay || !cartCloseBtn) return;
  
  // Open cart overlay when cart button is clicked
  cartButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      cartOverlay.classList.add('active');
      document.body.style.overflow = 'hidden'; // Prevent background scrolling
    });
  });
  
  // Close cart overlay when close button is clicked
  cartCloseBtn.addEventListener('click', function() {
    cartOverlay.classList.remove('active');
    document.body.style.overflow = '';
  });
  
  // Tab switching functionality
  cartTabs.forEach(tab => {
    tab.addEventListener('click', function() {
      const targetTab = this.getAttribute('data-tab');
      
      // Remove active class from all tabs and contents
      cartTabs.forEach(t => t.classList.remove('active'));
      tabContents.forEach(content => content.classList.remove('active'));
      
      // Add active class to clicked tab and corresponding content
      this.classList.add('active');
      document.getElementById(targetTab + 'Tab').classList.add('active');
    });
  });
  
  // Close cart overlay when clicking outside the content
  cartOverlay.addEventListener('click', function(e) {
    // Close when clicking on the overlay background (outside the content)
    if (e.target === cartOverlay) {
      cartOverlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  });
  
  // Also close when clicking on the document body outside the overlay
  document.addEventListener('click', function(e) {
    if (cartOverlay.classList.contains('active') && 
        !cartOverlay.contains(e.target) && 
        !e.target.closest('.cart-area') && 
        !e.target.closest('.action-btn[aria-label="Cart"]') &&
        !e.target.closest('.cart-icon') &&
        !e.target.closest('.cart-btn')) {
      cartOverlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  });
  
  // Close cart overlay with Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && cartOverlay.classList.contains('active')) {
      cartOverlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  });
  
  // Quantity controls
  // const quantitySelectors = document.querySelectorAll('.quantity-selector');
  // quantitySelectors.forEach(selector => {
  //   const minusBtn = selector.querySelector('.minus');
  //   const plusBtn = selector.querySelector('.plus');
  //   const qtyNumber = selector.querySelector('.qty-number');
    
  //   if (minusBtn && plusBtn && qtyNumber) {
  //     let currentQty = parseInt(qtyNumber.textContent);
      
  //     minusBtn.addEventListener('click', function() {
  //       if (currentQty > 1) {
  //         currentQty--;
  //         qtyNumber.textContent = currentQty;
  //       }
  //     });
      
  //     plusBtn.addEventListener('click', function() {
  //       currentQty++;
  //       qtyNumber.textContent = currentQty;
  //     });
  //   }
  // });
  
  // Remove item functionality
  const removeButtons = document.querySelectorAll('.remove-btn');
  removeButtons.forEach(button => {
    button.addEventListener('click', function() {
      const cartItem = this.closest('.cart-item');
      if (cartItem) {
        cartItem.style.opacity = '0';
        cartItem.style.transform = 'translateX(100%)';
        setTimeout(() => {
          cartItem.remove();
          // Update cart count if needed
          updateCartCount();
        }, 300);
      }
    });
  });
  
  // Function to update cart count
  function updateCartCount() {
    const cartItems = document.querySelectorAll('.cart-item');
    const cartTitle = document.querySelector('.cart-title');
    if (cartTitle) {
      cartTitle.textContent = `CART (${cartItems.length})`;
    }
  }
});

// Mobile Navbar functionality - Shop and Account buttons
window.addEventListener('DOMContentLoaded', function initMobileNavbar() {
  // Get mobile navbar elements for shop and account
  const shopBtn = document.querySelector('.shop-btn');
  const accountBtn = document.querySelector('.account-btn');
  
  // Shop button functionality (can be customized)
  if (shopBtn) {
    shopBtn.addEventListener('click', function() {
      // Redirect to shop page or open shop menu
      console.log('Shop button clicked');
      // You can add navigation logic here
      // window.location.href = '/shop';
    });
  }
  
  // Account button functionality (can be customized)
  if (accountBtn) {
    accountBtn.addEventListener('click', function() {
      // Redirect to account page or open account menu
      console.log('Account button clicked');
      // You can add navigation logic here
      // window.location.href = '/account';
    });
  }
});

// FAQ Accordion functionality
window.addEventListener('DOMContentLoaded', function initFAQ() {
  const faqItems = document.querySelectorAll('.faq-item');
  
  faqItems.forEach(item => {
    const question = item.querySelector('.faq-question');
    const icon = item.querySelector('.faq-icon');
    
    question.addEventListener('click', function() {
      const isActive = item.classList.contains('active');
      
      // Close all FAQ items
      faqItems.forEach(faqItem => {
        faqItem.classList.remove('active');
        const faqIcon = faqItem.querySelector('.faq-icon');
        faqIcon.innerHTML = '<svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.99989 6.70691L0.692139 1.39916L1.39989 0.691406L5.99989 5.29141L10.5999 0.691406L11.3076 1.39916L5.99989 6.70691Z" fill="white"/></svg>';
      });
      
      // Open clicked item if it wasn't active
      if (!isActive) {
        item.classList.add('active');
        icon.innerHTML = '<svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.99989 6.70691L0.692139 1.39916L1.39989 0.691406L5.99989 5.29141L10.5999 0.691406L11.3076 1.39916L5.99989 6.70691Z" fill="white"/></svg>';
      }
    });
  });
});

// Denim Collection Section functionality
window.addEventListener('DOMContentLoaded', function initDenimCollection() {
  const denimFitItems = document.querySelectorAll('.denim-fit-item');
  const denimModels = document.querySelectorAll('.denim-model');
  let isDesktop = window.innerWidth > 1024;
  
  console.log('Denim Collection initialized:', {
    denimFitItems: denimFitItems.length,
    denimModels: denimModels.length,
    isDesktop: isDesktop
  });

  // Function to update active state and show corresponding model
  function updateDenimFit(fitType) {
    console.log('Updating denim fit to:', fitType);
    
    // Remove active class from all items
    denimFitItems.forEach(item => item.classList.remove('active'));
    denimModels.forEach(model => model.classList.remove('active'));
    
    // Remove active class from all text items
    const denimTextItems = document.querySelectorAll('.denim-text-item');
    denimTextItems.forEach(item => item.classList.remove('active'));

    // Add active class to clicked/hovered navigation item
    const activeNavItem = document.querySelector(`.denim-fit-item[data-fit="${fitType}"]`);
    // Add active class to corresponding model image
    const activeModel = document.querySelector(`.denim-model[data-fit="${fitType}"]`);
    // Add active class to corresponding text content
    const activeTextItem = document.querySelector(`.denim-text-item[data-fit="${fitType}"]`);
    
    console.log('Found elements:', {
      activeNavItem: activeNavItem,
      activeModel: activeModel,
      activeTextItem: activeTextItem
    });
    
    if (activeNavItem) activeNavItem.classList.add('active');
    if (activeModel) activeModel.classList.add('active');
    if (activeTextItem) activeTextItem.classList.add('active');
  }

  // Desktop: Hover functionality
  if (isDesktop) {
    console.log('Setting up hover functionality for desktop');
    denimFitItems.forEach(item => {
      item.addEventListener('mouseenter', function() {
        const fitType = this.dataset.fit;
        console.log('Hover on:', fitType);
        updateDenimFit(fitType);
      });
    });
  }

  // Mobile/Tablet: Click functionality
  console.log('Setting up click functionality for all devices');
  denimFitItems.forEach(item => {
    item.addEventListener('click', function() {
      const fitType = this.dataset.fit;
      console.log('Click on:', fitType);
      updateDenimFit(fitType);
    });
  });

  // Handle window resize to switch between hover and click
  window.addEventListener('resize', function() {
    const newIsDesktop = window.innerWidth > 1024;
    
    if (newIsDesktop !== isDesktop) {
      // Reload the page or reinitialize if needed
      // For now, we'll just update the flag
      isDesktop = newIsDesktop;
    }
  });
});

document.addEventListener('DOMContentLoaded', function() {
  // collect items and convert to array for consistent behavior
  const imageItems = Array.from(document.querySelectorAll('.image-item'));

  // if no items found, stop — prevents "cannot read property 'classList' of undefined"
  if (imageItems.length === 0) return;

  let currentActiveIndex = 0;
  let isDragging = false;
  let startX = 0;
  let startY = 0;
  let currentX = 0;
  let currentY = 0;
  const dragThreshold = 50;

  // Initialize card positions
  function initializeCards() {
      imageItems.forEach((item, index) => {
          item.style.zIndex = 3 - index;
          item.classList.remove('active');
      });
      // Set first card as active (safe because we checked length)
      imageItems[0].classList.add('active');
  }

  // Rotate cards to next position
  function rotateCards() {
      const images = imageItems.map(item => {
          const img = item.querySelector('img');
          return img ? img.src : null;
      });

      const lastImage = images.pop();
      images.unshift(lastImage);

      imageItems.forEach((item, index) => {
          const img = item.querySelector('img');
          if (img && images[index]) {
              item.style.opacity = '0.7';
              setTimeout(() => {
                  img.src = images[index];
                  item.style.opacity = '1';
              }, 300);
          }
      });

      imageItems.forEach(item => item.classList.remove('active'));
      imageItems[0].classList.add('active');
  }

  // Rotate cards backward
  function rotateCardsBackward() {
      const images = imageItems.map(item => {
          const img = item.querySelector('img');
          return img ? img.src : null;
      });

      const firstImage = images.shift();
      images.push(firstImage);

      imageItems.forEach((item, index) => {
          const img = item.querySelector('img');
          if (img && images[index]) {
              item.style.opacity = '0.7';
              setTimeout(() => {
                  img.src = images[index];
                  item.style.opacity = '1';
              }, 300);
          }
      });

      imageItems.forEach(item => item.classList.remove('active'));
      imageItems[0].classList.add('active');
  }

  // Bring specific card to front
  function bringCardToFront(clickedCard) {
      imageItems.forEach(item => item.classList.remove('active'));
      clickedCard.classList.add('active');

      const maxZIndex = Math.max(...imageItems.map(item => parseInt(item.style.zIndex, 10) || 0));
      clickedCard.style.zIndex = maxZIndex + 1;

      imageItems.forEach((item, index) => {
          if (item !== clickedCard) {
              item.style.zIndex = 3 - index;
          }
      });
  }

  // Desktop mouse events
  imageItems.forEach((item) => {
      item.addEventListener('click', function(e) {
          if (!isDragging) {
              e.preventDefault();
              bringCardToFront(this);
          }
      });

      item.addEventListener('mousedown', function(e) {
          isDragging = true;
          startX = e.clientX;
          startY = e.clientY;
          this.classList.add('dragging');
      });

      document.addEventListener('mousemove', function(e) {
          if (isDragging) {
              currentX = e.clientX;
              currentY = e.clientY;
          }
      });

      document.addEventListener('mouseup', function() {
          if (isDragging) {
              const deltaX = currentX - startX;
              const deltaY = currentY - startY;

              if (Math.abs(deltaX) > dragThreshold) {
                  if (deltaX > 0) rotateCardsBackward();
                  else rotateCards();
              }

              isDragging = false;
              imageItems.forEach(i => i.classList.remove('dragging'));
          }
      });
  });

  // Touch events for mobile
  imageItems.forEach((item) => {
      let touchStartX = 0;
      let touchStartY = 0;
      let touchEndX = 0;
      let touchEndY = 0;

      item.addEventListener('touchstart', function(e) {
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
      }, { passive: true });

      item.addEventListener('touchmove', function(e) {
          // optional: remove e.preventDefault() to allow scrolling
      }, { passive: true });

      item.addEventListener('touchend', function(e) {
          touchEndX = e.changedTouches[0].clientX;
          touchEndY = e.changedTouches[0].clientY;

          const deltaX = touchEndX - touchStartX;
          const deltaY = touchEndY - touchStartY;

          if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > dragThreshold) {
              if (deltaX > 0) rotateCardsBackward();
              else rotateCards();
          } else if (Math.abs(deltaY) > Math.abs(deltaX) && Math.abs(deltaY) > dragThreshold) {
              rotateCards();
          } else {
              bringCardToFront(this);
          }
      }, { passive: true });
  });

  // Initialize
  initializeCards();
});


// // Product Detail Page Sticky Behavior
// document.addEventListener('DOMContentLoaded', function() {
//     const pdpRight = document.querySelector('.pdp-right');
//     const pdpLeft = document.querySelector('.pdp-left');
//     const firstImage = document.querySelector('.pdp-left .pdp-image:first-child');
    
//     if (pdpRight && pdpLeft && firstImage) {
//         let isStickyEnabled = true;
        
//         function handleStickyBehavior() {
//             const firstImageRect = firstImage.getBoundingClientRect();
//             const firstImageBottom = firstImageRect.bottom;
            
//             // If first image is out of view (scrolled past), disable sticky
//             if (firstImageBottom < 0 && isStickyEnabled) {
//                 pdpRight.classList.add('sticky-disabled');
//                 isStickyEnabled = false;
//             }
//             // If first image is back in view, enable sticky
//             else if (firstImageBottom >= 0 && !isStickyEnabled) {
//                 pdpRight.classList.remove('sticky-disabled');
//                 isStickyEnabled = true;
//             }
//         }
        
//         // Add scroll event listener
//         window.addEventListener('scroll', handleStickyBehavior);
        
//         // Initial check
//         handleStickyBehavior();
//     }
// });

// Product Detail Page Accordion Functionality
document.addEventListener('DOMContentLoaded', function() {
    const accordionSections = document.querySelectorAll('.info-section');
    
    accordionSections.forEach(section => {
        const expandBtn = section.querySelector('.expand-btn');
        const sectionTitle = section.querySelector('.section-title');
        const content = section.querySelector('.care-instructions') || section.querySelector('.accordion-content');
        
        if (expandBtn && content) {
            // Initially hide content
            content.style.maxHeight = '0px';
            content.style.opacity = '0';
            content.style.marginTop = '0px';
            
            // Function to toggle content
            function toggleContent() {
                const isExpanded = content.style.maxHeight !== '0px';
                
                // Toggle content visibility with smooth animation
                if (isExpanded) {
                    // Collapse
                    content.style.maxHeight = '0px';
                    content.style.opacity = '0';
                    content.style.marginTop = '0px';
                    expandBtn.style.transform = 'rotate(0deg)';
                } else {
                    // Expand
                    const scrollHeight = content.scrollHeight;
                    content.style.maxHeight = scrollHeight + 'px';
                    content.style.opacity = '1';
                    content.style.marginTop = '20px';
                    expandBtn.style.transform = 'rotate(180deg)';
                }
            }
            
            // Add click event listener to expand button
            expandBtn.addEventListener('click', toggleContent);
            
            // Add click event listener to section title
            if (sectionTitle) {
                sectionTitle.addEventListener('click', toggleContent);
            }
        }
    });

    // Initialize Special Offers Swiper
    const offersSwiper = new Swiper('.offers-swiper', {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        // autoplay: {
        //     delay: 5000,
        //     disableOnInteraction: false,
        // },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            768: {
                slidesPerView: 1,
                spaceBetween: 30,
            },
            1024: {
                slidesPerView: 1,
                spaceBetween: 40,
            }
        }
    });

    // Copy Offer Code Functionality
    const copyBtns = document.querySelectorAll('.copy-btn');
    copyBtns.forEach(btn => {
        btn.addEventListener('click', function() {
            const codeText = this.previousElementSibling.textContent;
            
            // Copy to clipboard
            navigator.clipboard.writeText(codeText).then(() => {
                // Show success feedback
                const originalText = this.innerHTML;
                this.innerHTML = `
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.5 4.5L6 12L2.5 8.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                `;
                
                setTimeout(() => {
                    this.innerHTML = originalText;
                }, 2000);
            }).catch(err => {
                console.error('Failed to copy: ', err);
            });
        });
    });
});

   var chooseOptionSlider = new Swiper(".choose-option-slider", {
  effect: "fade",
  fadeEffect: { crossFade: true },
  loop: true,
  speed: 600,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".choose-option-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".choose-option-next",
    prevEl: ".choose-option-prev",
  },
});


// PDP Mobile Swiper with Thumbnails (mobile only)
window.addEventListener('DOMContentLoaded', function initPdpMobileSwiper(){
  if (typeof Swiper === 'undefined') return;
  const container = document.querySelector('.mobile-pdp-slider');
  if (!container) return;

  function setup() {
    // Only on mobile
    if (window.innerWidth > 768) return { main: null, thumbs: null };

    const thumbs = new Swiper('.pdp-mobile-thumbs', {
      slidesPerView: 'auto',
      spaceBetween: 8,
      watchSlidesProgress: true,
      freeMode: true,
    });

    const main = new Swiper('.pdp-mobile-swiper', {
      loop: false,
      spaceBetween: 0,
      navigation: {
        nextEl: '.pdp-mobile-button-next',
        prevEl: '.pdp-mobile-button-prev',
      },
      thumbs: { swiper: thumbs },
    });

    return { main, thumbs };
  }

  let instances = setup();

  window.addEventListener('resize', function(){
    const isMobile = window.innerWidth <= 768;
    const hasInstances = instances && instances.main;

    if (isMobile && !hasInstances) {
      instances = setup();
    } else if (!isMobile && hasInstances) {
      instances.main.destroy(true, true);
      instances.thumbs.destroy(true, true);
      instances = { main: null, thumbs: null };
    }
  });
});

// Size Guide Drawer interactions
window.addEventListener('DOMContentLoaded', function initSizeGuideDrawer(){
  const drawer = document.getElementById('sizeGuideDrawer');
  if (!drawer) return;
  const openBtn = document.querySelector('.size-guide-link');
  const overlay = drawer.querySelector('.drawer-overlay');
  const closeBtn = drawer.querySelector('.drawer-close');

  function openDrawer(){
    drawer.classList.add('active');
    document.body.style.overflow = 'hidden';
    drawer.setAttribute('aria-hidden', 'false');
  }
  function closeDrawer(){
    drawer.classList.remove('active');
    document.body.style.overflow = '';
    drawer.setAttribute('aria-hidden', 'true');
  }

  if (openBtn){
    openBtn.addEventListener('click', function(e){
      e.preventDefault();
      openDrawer();
    });
  }
  overlay.addEventListener('click', closeDrawer);
  closeBtn.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && drawer.classList.contains('active')){
      closeDrawer();
    }
  });
});

window.addEventListener('DOMContentLoaded', function initInnovationSwiper() {
    const swiperContainer = document.querySelector('.innovation-swiper');
    const collections = document.querySelectorAll('.innovation-collection');
    const descriptions = document.querySelectorAll('.innovation-description');
    
    if (!swiperContainer) return;
    
    // Initialize Swiper
    const innovationSwiper = new Swiper('.innovation-swiper', {
        slidesPerView: 1.3,
        spaceBetween: 25,
        loop: true,
        centeredSlides: false,
        initialSlide: 0, // Start from first slide
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: '.innovation-nav-next',
            prevEl: '.innovation-nav-prev',
        },
        on: {
            slideChange: function () {
                const activeIndex = this.realIndex; // Get real index (ignoring loop)
                updateContent(activeIndex);
            }
        },
        breakpoints: {
          767: {
              slidesPerView: 1.6,
              spaceBetween: 20,
          },
        
      }
    });
    
    function updateContent(index) {
        // Update content visibility - show only current slide content
        collections.forEach(collection => {
            collection.classList.remove('active');
            if (collection.getAttribute('data-slide') == index) {
                collection.classList.add('active');
            }
        });
        
        descriptions.forEach(description => {
            description.classList.remove('active');
            if (description.getAttribute('data-slide') == index) {
                description.classList.add('active');
            }
        });
    }
    
    // Initialize content for first slide
    updateContent(0);
});

// // Sticky PDP Cart visibility
// window.addEventListener('DOMContentLoaded', function initStickyPdpCart(){
//   const sticky = document.querySelector('.sticky-pdp-cart');
//   const mainCta = document.querySelector('.btn-add-cart');
//   if (!sticky || !mainCta) return;

//   const observer = new IntersectionObserver(([entry]) => {
//     if (entry.isIntersecting) {
//       sticky.classList.remove('active');
//     } else {
//       sticky.classList.add('active');
//     }
//   }, { threshold: 0, rootMargin: '0px 0px -80% 0px' });

//   observer.observe(mainCta);

//   // Delegate click from sticky bar to main CTA
//   const stickyBtn = sticky.querySelector('.spc-btn');
//   if (stickyBtn) {
//     stickyBtn.addEventListener('click', function(e){
//       e.preventDefault();
//       mainCta.click();
//     });
//   }
// });
	


// KRISHNA JS

 

        